import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Plus, Search } from "lucide-react";

export default function Customers() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ first_name: "", last_name: "", phone: "", email: "", notes: "" });
  const load = useCallback(() => api.get(`/customers?q=${encodeURIComponent(q)}`).then(r => setItems(r.data)), [q]);
  useEffect(() => { load(); }, [load]);
  const save = async () => { try { await api.post("/customers", form); toast.success("Customer added"); setOpen(false); setForm({ first_name: "", last_name: "", phone: "", email: "", notes: "" }); load(); } catch { toast.error("Failed"); } };
  return (
    <div>
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div><h1 className="text-3xl font-bold tracking-tight">Customers</h1><p className="text-slate-600 mt-1">Everyone who's called or booked.</p></div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button data-testid="add-customer-btn" className="rounded-xl bg-blue-600 hover:bg-blue-700"><Plus className="w-4 h-4 mr-1" />Add customer</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>New customer</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div className="grid grid-cols-2 gap-3">
                <div><Label>First name</Label><Input data-testid="cust-first" value={form.first_name} onChange={(e) => setForm({ ...form, first_name: e.target.value })} className="mt-1.5" /></div>
                <div><Label>Last name</Label><Input data-testid="cust-last" value={form.last_name} onChange={(e) => setForm({ ...form, last_name: e.target.value })} className="mt-1.5" /></div>
              </div>
              <div><Label>Phone</Label><Input data-testid="cust-phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="mt-1.5" /></div>
              <div><Label>Email</Label><Input data-testid="cust-email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1.5" /></div>
              <Button data-testid="cust-save-btn" onClick={save} className="w-full rounded-xl bg-blue-600 hover:bg-blue-700">Save</Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>
      <div className="mt-6 relative max-w-md">
        <Search className="w-4 h-4 absolute left-3 top-3 text-slate-400" />
        <Input data-testid="customer-search" placeholder="Search customers…" value={q} onChange={(e) => setQ(e.target.value)} className="pl-9" />
      </div>
      <div className="mt-4 bg-white border border-slate-200 rounded-2xl overflow-hidden">
        {items.length === 0 ? (
          <div className="p-10 text-center text-slate-500">No customers yet.</div>
        ) : (
          <div className="overflow-x-auto"><table className="w-full text-sm min-w-[560px]" data-testid="customers-table">
            <thead className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wider">
              <tr><th className="text-left px-6 py-3">Name</th><th className="text-left px-6 py-3">Phone</th><th className="text-left px-6 py-3">Email</th><th className="text-left px-6 py-3">Visits</th><th className="text-left px-6 py-3">Last</th></tr>
            </thead>
            <tbody>
              {items.map(c => (
                <tr key={c.id} className="border-t border-slate-100" data-testid={`customer-row-${c.id}`}>
                  <td className="px-6 py-4 font-medium">{c.first_name} {c.last_name}</td>
                  <td className="px-6 py-4">{c.phone}</td>
                  <td className="px-6 py-4">{c.email}</td>
                  <td className="px-6 py-4">{c.appointment_count}</td>
                  <td className="px-6 py-4 text-slate-500">{c.last_appointment ? new Date(c.last_appointment).toLocaleDateString() : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table></div>
        )}
      </div>
    </div>
  );
}
